import React from 'react'
import PropTypes from 'prop-types'
import Text from '../Text/Text'
import styles from './seeMoreButton.module.scss'

const SeeMoreButton = ({ handlePaginate }) => {
  return (
    <button className={styles.container} type="button" onClick={handlePaginate}>
      <Text font="custom" color="gray" variation="dark" size="xs">
        ver mais
      </Text>
    </button>
  )
}

SeeMoreButton.propTypes = {
  handlePaginate: PropTypes.func.isRequired
}

export default React.memo(SeeMoreButton)
